import { shopifyFetch } from "@/utils/ShopifyFetch";

export async function getProductsByIds(productIds) {
  const query = `
    query GetProductsByIds($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          description
          descriptionHtml
          metafields(
            identifiers: [
              {namespace: "custom", key: "additional_description"},
              {namespace: "custom", key: "quantity_pack"}
            ]
          ) {
            key
            value
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          images(first: 1) {
            edges {
              node {
                url
                altText
                width
                height
              }
            }
          }
          sellingPlanGroups(first: 1) {
            edges {
              node {
                sellingPlans(first: 1) {
                  edges {
                    node {
                      checkoutCharge {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
                availableForSale
                quantityAvailable
                compareAtPrice {
                  amount
                  currencyCode
                }
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
  `;

  const response = await shopifyFetch({
    query,
    variables: {
      ids: productIds,
    },
  });

  return response;
}

export async function getProductPricing(productId) {
  const query = `
    query GetProductPricing($id: ID!) {
      node(id: $id) {
        ... on Product {
          variants(first: 1) {
            edges {
              node {
                id
                availableForSale
                quantityAvailable
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                product {
                  sellingPlanGroups(first: 10) {
                    edges {
                      node {
                        name
                        sellingPlans(first: 1) {
                          edges {
                            node {
                              checkoutCharge {
                                value {
                                  ... on MoneyV2 {
                                    amount  
                                  }
                                } 
                              }
                            }
                          }
                        }
                      } 
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  try {
    const {
      body: { data },
    } = await shopifyFetch({
      query,
      variables: {
        id: productId,
      },
    });

    if (!data?.node?.variants?.edges?.[0]) {
      console.error("No variant data returned from Shopify");
      return null;
    }

    return data.node.variants.edges[0].node;
  } catch (error) {
    console.error("Error fetching pricing:", error);
    throw error;
  }
}
